import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  const arabicLine = "أحد منتجات شركة ترست اي دي تكنو للتطوير والابتكار ذ.م.م";
  const englishLine = "Trust Ed Techno for Development and Innovation L.L.C";

  const legalLinks = [
    { slug: "terms", label: t("footer_terms") },
    { slug: "privacy", label: t("footer_privacy") },
    { slug: "refund", label: t("footer_refund") },
    { slug: "cookies", label: t("footer_cookies") },
  ];

  return (
    <footer className="border-t border-zinc-200/80 bg-white/40 backdrop-blur-sm">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 flex flex-col items-center text-center gap-5">
        <a
          href="https://TrustEdTechno.com"
          target="_blank"
          rel="noreferrer"
          data-testid="company-footer-link"
          className="group inline-flex flex-col items-center gap-3 transition-opacity hover:opacity-90"
        >
          <img
            src="/brand/trust-ed-techno.svg"
            alt="Trust Ai D Techno"
            className="w-14 h-14 object-contain"
          />
          <div className="space-y-0.5">
            <p className="text-sm font-medium text-zinc-700 leading-snug" dir="rtl">
              {arabicLine}
            </p>
            <p className="text-[12px] text-zinc-500 leading-snug" dir="ltr">
              {englishLine}
            </p>
            <p className="text-[12px] font-mono text-zinc-900 group-hover:underline underline-offset-4 mt-1" dir="ltr">
              TrustEdTechno.com →
            </p>
          </div>
        </a>

        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-zinc-500" data-testid="footer-legal">
          {legalLinks.map((l) => (
            <Link
              key={l.slug}
              to={`/legal/${l.slug}`}
              className="hover:text-zinc-900 hover:underline underline-offset-4"
              data-testid={`footer-legal-${l.slug}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="w-12 h-px bg-zinc-200" />

        <div className="space-y-1">
          <p className="text-[11px] text-zinc-400 font-mono tracking-wide" dir="ltr">
            © {year} Trust Ed Techno · All rights reserved
          </p>
          <p className="text-[11px] text-zinc-400" dir="rtl">
            جميع الحقوق محفوظة · {t("brand")}
          </p>
        </div>
      </div>
    </footer>
  );
}
